import { BaseKey, useApiUrl, useCustomMutation } from '@refinedev/core';
import { useLocaleStore } from 'stores/localeStore';
import { getUserInfoFromCache } from 'utility/helper';

interface KassanovaSyncData {
  productItemIds?: BaseKey[];
  productItemNos?: BaseKey[];
}

export const useKassanovaSync: () => {
  kassanovaSyncProductItems: (input: KassanovaSyncData) => void;
  kassanovaSyncCampaignDates: (input: KassanovaSyncData) => void;
} = () => {
  const apiUrl = useApiUrl();
  const { mutate } = useCustomMutation();
  const { locale } = useLocaleStore();
  const userInfo = getUserInfoFromCache();

  const postKassanovaAction = (
    path: string,
    description: string,
    input: KassanovaSyncData
  ) => {
    mutate({
      url: `${apiUrl}${path}`,
      method: "post",
      successNotification: () => {
        return {
          message: "",
          description,
          type: "success",
        };
      },
      values: {
        ids: input?.productItemIds ?? [],
        articleNumbers: input?.productItemNos ?? [],
      },
      config: {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          lang: locale,
        }
      }
    });
  };
  
  const kassanovaSyncProductItems = (input: KassanovaSyncData) => {
    postKassanovaAction(
      "/actions/kassanova-synchronize",
      "Kassanova bakgrundsjobb skapades",
      input
    );
  };

  const kassanovaSyncCampaignDates = (input: KassanovaSyncData) => {
    postKassanovaAction(
      "/actions/kassanova-synchronize-campaign-dates",
      "Kassanova kampanjdatum-jobb skapades",
      input
    );
  };

  return { kassanovaSyncProductItems, kassanovaSyncCampaignDates };
};